export default __webpack_public_path__ + "static/media/SCC_logo_COL_invert.f550bf61.png";